import { createScopedDescriptor } from '../../globalState/api';
import { getBuildTimePropertyNames } from '../../globalState/initialize';

// Properties initialized in quartz/globalState/initialize.ts
export const COPILOT_LAYOUT_TYPE = createScopedDescriptor(getBuildTimePropertyNames().copilotLayoutType, 'BROWSING_CONTEXT');